import React from "react";
import "../../../../assets/styles/_utilityClasses.scss";
import PropTypes from "prop-types";
import "./selectCall.scss";

const SelectCall = ({onSampleCallSelect, onFileSelect}) => {
    return <div className={"select-call-container"}>
        <p className={"steps-title"}>Upload a call</p>
        <button className={"colored-button medium-font-size"}  onClick={onFileSelect}>Upload your call</button>
        {/*<div className="tile">file.wav</div>*/}
        <p className={"or-option-text"}> Or choose a sample call:</p>
        <div className={"sample-calls"}>
        <button className={"colored-button medium-font-size"}  onClick={onSampleCallSelect}>Sales Call</button>
        <button className={"colored-button medium-font-size"}  onClick={onSampleCallSelect}>Customer Support Call</button>
        </div>
    </div>
}

export default SelectCall

SelectCall.prototype = {
    onSelect: PropTypes.func
}